import TextSizeControl from "./TextSizeControl";

export default TextSizeControl;
